import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Store, UtensilsCrossed, ChefHat, Users, Plus, LogOut } from 'lucide-react';

const RestaurantSelector = ({ 
  restaurants, 
  onSelectRestaurant, 
  isPopup, 
  onLogout 
}) => {
  return (
    <div className={`${isPopup ? 'h-screen' : 'h-[calc(100vh-120px)]'} flex items-center justify-center bg-gradient-hero`} data-testid="restaurant-selection">
      <div className="max-w-3xl w-full mx-4">
        <div className="text-center mb-8">
          <div className="h-20 w-20 rounded-2xl bg-white/20 flex items-center justify-center mx-auto mb-4 backdrop-blur">
            <Store className="h-10 w-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Manrope' }}>Select Restaurant</h1>
          <p className="text-white/70">Choose a restaurant to start taking orders</p>
        </div>
        
        {restaurants.length === 0 ? (
          <div className="text-center">
            <p className="text-white/70 mb-4">No restaurants found. Please create a restaurant first.</p>
            <Button 
              onClick={() => window.location.href = '/restaurants'} 
              className="bg-white text-orange-600 hover:bg-white/90"
            >
              <Plus className="h-4 w-4 mr-2" /> Create Restaurant
            </Button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {restaurants.filter(r => r.is_active !== false).map((restaurant) => (
              <Card 
                key={restaurant.id}
                className="cursor-pointer hover:shadow-xl hover:-translate-y-1 transition-all duration-200 bg-white/95 backdrop-blur border-white/20"
                onClick={() => onSelectRestaurant(restaurant)}
                data-testid={`select-restaurant-${restaurant.id}`}
              >
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div className="h-14 w-14 rounded-xl bg-gradient-orange flex items-center justify-center flex-shrink-0">
                      <UtensilsCrossed className="h-7 w-7 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-bold text-lg text-gray-800 truncate">{restaurant.name}</h3>
                      {restaurant.cuisine_type && (
                        <Badge variant="secondary" className="mt-1">
                          <ChefHat className="h-3 w-3 mr-1" />
                          {restaurant.cuisine_type}
                        </Badge>
                      )}
                      <div className="flex items-center gap-4 mt-3 text-sm text-gray-500">
                        <span className="flex items-center gap-1">
                          <Users className="h-4 w-4" />
                          {restaurant.table_count || 0} tables
                        </span>
                        <span className="flex items-center gap-1">
                          <UtensilsCrossed className="h-4 w-4" />
                          {restaurant.menu_item_count || 0} items
                        </span>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}

        {isPopup && onLogout && (
          <div className="text-center mt-8">
            <Button 
              onClick={onLogout}
              variant="ghost"
              className="text-white/70 hover:text-white hover:bg-white/10"
            >
              <LogOut className="h-4 w-4 mr-2" /> Logout
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RestaurantSelector;
